module.exports = __webpack_public_path__ + "img/greece.43b5644.webp";